import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';

import { useSurveyData } from '../api/hooks/queries/useSurveyData';
import LoadingBackdrop from '../components/LoadingBackdrop';
import MainLayout from '../layouts/MainLayout';
import SampleDataPage from '../pages/SampleDataPage';
import useQreId from '../hooks/useQreId';
import BadQreIdPage from '../pages/BadQreIdPage/BadQreIdPage';

const AppRouter: FC = () => {
  const { isValid, qreIdRawValue, qreId } = useQreId();
  const { isLoading, isError, error } = useSurveyData();

  if (!isValid || isError) {
    return (
      <Routes>
        <Route path="/*" element={<BadQreIdPage qreIdValue={qreIdRawValue} error={error as Error | undefined} />} />
      </Routes>
    );
  }

  if (isLoading) {
    return <LoadingBackdrop isLoading />;
  }

  return (
    <Routes>
      <Route path="/" element={<MainLayout qreId={qreId} />}>
        <Route path="/" element={<SampleDataPage qreId={qreId} />} />
      </Route>
    </Routes>
  );
};

export default AppRouter;
